import React from 'react'

export const TemplateContext = React.createContext({
  templateName: 'home',
  setTemplateName: () => {},
  pageTitle: '',
  setPageTitle: () => {},
  configuration: {},
} as any)
